import barba from '@barba/core'
import { Sane } from 'sane-ui'
import * as components from '../components'

const initBarba = function () {
  const pageTransition = $('.page-transition').data('PageTransition')
  const $heroMenu = $('.hero-menu')
  const $footerTop = $('.site-footer__top')
  const heroMenu = $heroMenu.data('HeroMenu')
  let $link

  barba.init({
    transitions: [{
      leave ({ current, next, trigger }) {
        // do something with `current.container` for your leave transition
        // then return a promise or use `this.async()`
        return new Promise(resolve => {
          const heroMenuWasOpen = heroMenu.isOpen
          heroMenu.close()
          pageTransition.animateIn(() => {
            // If the menu was open upon navigation (common scenario: we clicked link from the menu)
            // then wait until it's closed and then scroll to top. That's because we're doing
            // some overflow magic when the menu is toggled.
            if (heroMenuWasOpen) {
              $heroMenu.one('Toggleable/closed', () => { $(window).scrollTop(0) })
            } else {
              $(window).scrollTop(0)
            }

            if (typeof trigger === 'string') {
              $link = $heroMenu.find(`a[href="${next.url.href}"]`)
              if ($link.length === 0) {
                const href = next.url.href.replace(/(http|https):/, '')
                $link = $heroMenu.find(`a[href="${href}"]`)
              }
            } else {
              $link = $(trigger)
            }

            // Main nav `active` class switching.
            $heroMenu.find('.active').removeClass('active')
            $link.closest('li').addClass('active')

            $(current.container).remove()
            resolve()
          })
        })
      },
      enter ({ current, next }) {
        // do something with `next.container` for your enter transition
        // then return a promise or use `this.async()`
        return new Promise(resolve => {
          let hasFooterTop = $(next.container).data('hft')
          hasFooterTop = hasFooterTop !== undefined ? hasFooterTop : true
          $footerTop.toggleClass('d-none', !hasFooterTop)

          pageTransition.animateOut(() => {
            Sane.initComponents(components, $('.main').find('[data-component]'))
            resolve()

            // Trigger Google Analytics Pageviews.
            // @link https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
            if (typeof window.ga !== 'function') {
              return
            }

            window.ga('set', 'page', window.location.pathname)
            window.ga('send', 'pageview')
          })
        })
      },
    }],
    logLevel: 4,
  })
}

export { initBarba }



// WEBPACK FOOTER //
// ./scripts/util/barba.js